<main class="circle-gradient-1">
  <section class="breadcrumb-sec event-sec">
    <div class="container">
        <div class="row g-0">
            <div class="col-lg-6 col-md-6">
                <ul class="breadcrumb">
                    <li><a routerLink="/">Home</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li><a href="events">Events</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li><a routerLink="/events" fragment="academic">Academic</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li> Celebration of Yoga day</li>
                </ul>
                <div class="sec-title">
                    <h1><span>Celebration of Yoga day</span></h1>
                    <p>GHRCACS, Pune celebrated International Yoga Day 2025 on 21st June 2025.
                    </p>

                </div>
            </div>
        </div>
        <div class="breadcrumb-overlay overflow-hidden"
            style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d2.webp);">
        </div>
    </div>
  </section>
  <section class="section-lg">
    <div class="container">
      <div class="sec-title text-center">
          <h2><span>Photo Gallery</span></h2>
      </div>
      <div class="demo-gallery">
        <div class="demo-gallery">
          <ul  appLightgallery>
              <li class="grid-item1"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d5.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d5.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d5.webp">
                  </a>
              </li>
              <li class="grid-item2"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d1.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d1.webp">
                  </a>
              </li>
              <li class="grid-item3 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d2.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d2.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d2.webp">
                  </a>
              </li>
              <li class="grid-item4 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d3.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d3.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d3.webp">
                  </a>
              </li>
              <li class="grid-item5 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d4.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d4.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d4.webp">
                  </a>
              </li>
              <li class="grid-item6 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d5.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d5.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/yoga-d5.webp">
                  </a>
              </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</main>
